<carm-card class="carm-widget carm-summary-widget">
  <carm-card-title>
    <div class="row">
      <div
      class="col-md-12 inline-content"
      data-cy="penalties-homepage-title">
        <span>{{'dashboard.widgets.penalties.title' | translate }}</span>
        <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
          {{'dashboard.widgets.penalties.tooltip' | translate }}
        </carm-popover>
      </div>
    </div>
  </carm-card-title>
  <carm-card-content>
    <div class="row">
      <div
      class="col-md-12 mrgn-tp-sm text-center font-1_3x"
      data-cy="unpaid-penalties">
        <strong>{{'dashboard.widgets.penalties.description' | translate }}</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mrgn-tp-md text-center font-2_5x">
        <strong *ngIf="!loading">{{ penalties }}</strong>
        <mat-progress-spinner
        *ngIf="loading"
        attr.aria-label="{{ 'application_features.loading' | translate }}"
        class="mat-spinner-color spinner-styling"
        mode="indeterminate"
        value="50"
      >
      </mat-progress-spinner>
      </div>
    </div>
    <div *ngIf="!loading" class="row">
      <div class="col-md-12 mrgn-tp-sm text-center">
        <em><a
          [carmRouterLink]="viewAllPenaltiesUrl"
          data-cy="view-all-penalties">{{'dashboard.widgets.penalties.view_all_requests' | translate }}</a></em>
      </div>
    </div>
  </carm-card-content>
</carm-card>

